<template>
  <div class="team_operate container">
    <div class="header">
      <el-page-header @back="back" :content="isSet ? '创建团队' : '加入团队'">
      </el-page-header>
    </div>
    <div class="main">
      <set-team v-if="isSet" @back="back" />
      <join-team v-else @back="back" />
    </div>
  </div>
</template>

<script>
import setTeam from "./setTeam.vue";
import joinTeam from "./joinTeam.vue";
export default {
  name: "teamOperate",
  components: {
    joinTeam,
    setTeam,
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
  computed: {
    isSet() {
      return this.$route.query.type == 1;
    },
  },
};
</script>

<style lang="less" scoped>
.team_operate {
  .header {
    padding: 30px;
    background: #fff;
    ::v-deep .el-page-header {
      .el-page-header__content {
        font-size: 14px;
      }
    }
  }

  .main {
    margin: 30px 20px 0;
    padding: 60px 285px;
    text-align: left;
    background: #fff;
  }
}
</style>